import React from "react";
import Container from "../container/Container";
import "./style.css";

const BlogPostDetails = ({ post }) => {
    return (
        <Container>
            <div className="blog-post-details">
                <section className="blog-post-details-summary">
                    <p
                        dangerouslySetInnerHTML={{
                            __html: post.frontmatter.description || post.excerpt,
                        }}
                        itemProp="description"
                        className="blog-post-summary"
                    />
                </section>
                <article
                    className="blog-post"
                    itemScope
                    itemType="http://schema.org/Article"
                >
                    <section
                        dangerouslySetInnerHTML={{ __html: post.html }}
                        itemProp="articleBody"
                    />
                </article>
            </div>
        </Container>
    );
}

export default BlogPostDetails;
